import React from 'react';
import {
  IBreakdownFieldsFragment,
  QueryType,
} from '../../../../utils/apollo/graphqlSchema';
import { orderIconLookup } from '../../../../utils/builder';
import { IndexedIcon, SvgIcon } from '../../../Icon';
import * as BuilderInfoUI from '../../BuilderInfoUI';
import InfoPopupBreakdownGroups from './InfoPopupBreakdownGroups';
import ThinDivider from '../../../ThinDivider';

interface IProps {
  breakdown: IBreakdownFieldsFragment;
  queryType: QueryType;
}

const InfoPopupBreakdown = ({ breakdown, queryType }: IProps) => {
  const { groupbys, cohortRefs, overall, order } = breakdown;

  return (
    <>
      {groupbys?.length > 0 && (
        <>
          <ThinDivider layout="horizontal" size="full" />
          <BuilderInfoUI.VerticalNestedRow>
            <BuilderInfoUI.HighlightedLabel>
              Breakdown
            </BuilderInfoUI.HighlightedLabel>
            <InfoPopupBreakdownGroups groupbys={groupbys} />
          </BuilderInfoUI.VerticalNestedRow>
        </>
      )}
      {cohortRefs?.length > 0 && (
        <>
          <ThinDivider layout="horizontal" size="full" />
          <BuilderInfoUI.HorizontalRow>
            <BuilderInfoUI.HighlightedLabel>
              Segment
            </BuilderInfoUI.HighlightedLabel>
            {cohortRefs.map((_, index) => (
              <BuilderInfoUI.IconContainer
                key={`breakdown-cohort-info-${index}`}
              >
                <IndexedIcon
                  name="named-cohort"
                  positiveIndex={index + 1}
                  isActive={true}
                />
              </BuilderInfoUI.IconContainer>
            ))}
          </BuilderInfoUI.HorizontalRow>
        </>
      )}
      <ThinDivider layout="horizontal" size="full" />
      <BuilderInfoUI.HorizontalRow>
        <SvgIcon name={orderIconLookup[order]} width={16} height={16} />
        {queryType !== QueryType.DataTable && (
          <BuilderInfoUI.PlainInfo>
            <BuilderInfoUI.InfoLabel>Overall</BuilderInfoUI.InfoLabel>
            <BuilderInfoUI.BorderedInfo>
              {overall ? 'True' : 'False'}
            </BuilderInfoUI.BorderedInfo>
          </BuilderInfoUI.PlainInfo>
        )}
      </BuilderInfoUI.HorizontalRow>
    </>
  );
};

export default InfoPopupBreakdown;
